/**
 * useIsMobile — reactive boolean for `(max-width: 767px)` viewport.
 *
 * Used by the Report Web/PDF toggle (desktop → embedded PDF iframe,
 * mobile → PDF-styled web layout because mobile browsers handle inline
 * PDFs inconsistently), and anywhere else that needs to branch on
 * "mobile-shaped viewport" without rolling its own matchMedia listener.
 */
import { useEffect, useState } from "react";

const MOBILE_QUERY = "(max-width: 767px)";

export default function useIsMobile() {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === "undefined") return false;
        return window.matchMedia(MOBILE_QUERY).matches;
    });

    useEffect(() => {
        if (typeof window === "undefined") return undefined;
        const mql = window.matchMedia(MOBILE_QUERY);
        const sync = () => setIsMobile(mql.matches);
        mql.addEventListener("change", sync);
        return () => mql.removeEventListener("change", sync);
    }, []);

    return isMobile;
}
